import { PROD_HUB_BASE_URL } from "@memorang/constants";

const ENDPOINT_SESSION_ANALYSIS = `${PROD_HUB_BASE_URL}/api/v2/ai/sessionAnalysis`;

const events = {
	viewReportClicked: "mem_view_report_clicked",
	fullReportViewed: "mem_full_report_viewed",
	readingTime: "mem_reading_time",
};
export { ENDPOINT_SESSION_ANALYSIS, events };
